export default "__VITE_ASSET__Brn3PNFP__"